<template>
  <a-range-picker
    v-model="currentValue"
    :open="isOpen"
    :allowClear="allowClear"
    :defaultValue="defaultValue"
    :disabledTime="disabledTime"
    :disabledDate="disabledDate"
    :getCalendarContainer="getCalendarContainer"
    @change="onChange"
    @openChange="onOpenChange"
  >
    <!-- 自定义icon -->
    <div slot="suffixIcon">
      <slot name="suffixIcon">
        <a-icon slot="suffixIcon" type="calendar" />
      </slot>
    </div>
    <!-- 自定义尾部 -->
    <div
      v-if="cycles.length"
      class="cycle-footer"
      slot="renderExtraFooter"
    >
      <!-- 周期按钮 -->
      <a-button
        class="cycle-btn"
        size="small"
        v-for="(item, index) in cycles"
        :key="index"
        @click="touchCycle(item)"
      >{{ item.title }}</a-button>
    </div>
  </a-range-picker>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    // 日期
    value: {
      type: Array,
      default: () => []
    },
    // 默认日期
    defaultValue: {
      type: Array,
      default: () => []
    },
    // 控制弹层是否展开
    open: {
      type: Boolean,
      default: false
    },
    // 是否显示清除按钮
    allowClear: {
      type: Boolean,
      default: true
    },
    // 展示的日期格式
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    // 不可选择的时间
    disabledTime: {
      type: Function,
      default: undefined
    },
    // 不可选择的日期
    disabledDate: {
      type: Function,
      default: undefined
    },
    // 定义浮层的容器
    getCalendarContainer: {
      type: Function,
      default: undefined
    },
    // 时间
    cycles: {
      type: Array,
      default: () => [
        {
          title: '近7天',
          value: 7
        },
        {
          title: '近30天',
          value: 30
        },
        {
          title: '近90天',
          value: 90
        },
        {
          title: '近180天',
          value: 180
        }
      ]
    }
  },
  watch: {
    // 日期
    value: {
      handler (newData) { this.currentValue = newData }
    },
    // 控制弹层是否展开
    open: {
      handler (newData) { this.isOpen = newData }
    }
  },
  data () {
    return {
      // 当前时间
      currentValue: undefined,
      // 展开收起
      isOpen: false
    }
  },
  methods: {
    moment,
    // 时间切换
    onChange(date, dateString) {
      // 回调
      this.$emit('change', date, dateString)
    },
    // 弹出日历和关闭日历的回调
    onOpenChange (status) {
      // 记录
      this.isOpen = status
      // 回调
      this.$emit('openChange', status)
    },
    // 选择指定周期
    touchCycle (item) {
      // 开始时间
      const start = moment().subtract(item.value, 'days')
      // 结束时间
      const end = moment()
      // 时间数组
      const date = [start, end]
      // 时间字符串数组
      const dateString = [start.format(this.format), end.format(this.format)]
      // 设置
      this.currentValue = date
      // 回调
      this.onChange(date, dateString)
      // 关闭弹层
      this.isOpen = false
    }
  }
}
</script>

<style lang="less" scoped>
.cycle-footer {
  height: 40px;
  display: flex;
  align-items: center;
}
.cycle-btn {
  width: 70px;
  height: 26px;
  margin-left: 12px;
  font-size: 13px;
}
.cycle-btn:first-child {
  margin-left: 4px;
}
</style>